import { render, staticRenderFns } from "./ServiceSummary.vue?vue&type=template&id=b1d518b2&"
import script from "./ServiceSummary.vue?vue&type=script&lang=js&"
export * from "./ServiceSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports